import { Component } from 'react';
import { SettingsContext } from '@wu/widget-core';
import { request } from './request';

// TODO: Убрать userId и оставить только auth

export class Data extends Component {
  static defaultProps = {
    chunkSize: 5,
    limit: 0,
    params: {},
    onError: () => {},
    onUpdate: () => {}
  };

  static contextType = SettingsContext;

  state = {
    settings: null,
    data: null,
    stack: null,
    hasNextPage: true,
    hasNextItems: true,
    loading: false,
    error: null
  };

  componentDidMount() {
    const { dataType } = this.props;
    this.setState({ settings: this.context }, this.next);

    if (dataType === 'object') {
      this.next();

      this.setState({
        data: null,
        stack: null
      });
    } else if (dataType === 'array') {
      this.setState({
        data: [],
        stack: []
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      chunkSize: prevChunkSize,
      limit: prevLimit,
      sourceName: prevSourceName,
      params: { sort: prevSort }
    } = prevProps;

    const { apiUrl } = this.context;
    const {
      chunkSize,
      limit,
      sourceName,
      params: { sort }
    } = this.props;
    const {
      settings: { apiUrl: prevApiUrl }
    } = this.state;

    const isPropsChanged =
      prevApiUrl !== apiUrl ||
      prevChunkSize !== chunkSize ||
      prevLimit !== limit ||
      prevSourceName !== sourceName ||
      prevSort !== sort;

    if (isPropsChanged) {
      this.reset(() => {
        this.next();
      }, this.context);
    }
  }

  next = async () => {
    const { chunkSize, onError, onUpdate, dataType } = this.props;

    this.setState({ loading: true });

    try {
      await this.ensureItemsEnough();
    } catch (error) {
      if (error.name !== 'AbortError') {
        this.setState(
          {
            error,
            loading: false
          },
          () => onError(error)
        );
      }

      return;
    }

    return new Promise(async (resolve) => {
      this.setState(
        ({ stack, data, hasNextPage }) => {
          let nextData;
          let hasNextItems;

          if (dataType === 'array') {
            nextData = stack.slice(0, data.length + chunkSize);
            hasNextItems =
              nextData.length >= chunkSize &&
              (hasNextPage || stack.length > nextData.length);
          } else {
            nextData = stack;
          }

          return {
            hasNextItems,
            data: nextData,
            loading: false
          };
        },
        () => {
          const { data } = this.state;
          onUpdate(data);
          resolve(data);
        }
      );
    });
  };

  reset(callback = () => {}, settings = null) {
    this.setState(
      {
        settings,
        data: [],
        stack: [],
        hasNextPage: true,
        nextPageLink: '',
        hasNextItems: true,
        loading: false,
        error: null
      },
      callback
    );
  }

  async ensureItemsEnough() {
    const { chunkSize, dataType } = this.props;
    const { stack, data, hasNextPage } = this.state;

    if (dataType === 'array') {
      if (chunkSize < stack.length - data.length) {
        return true;
      }

      if (!hasNextPage) {
        return false;
      }
    } else if (dataType === 'object' && stack) {
      return true;
    }

    await this.loadNextPage();

    return true;
  }

  checkCache(url) {
    const { getCache } = this.props.cache;
    return getCache(url, 3600).catch(() => null);
  }

  createURL() {
    const { sourceName, sourceType, params } = this.props;
    const { nextPageLink } = this.state;

    if (nextPageLink) {
      return nextPageLink;
    }

    const urlParams = new URLSearchParams(params);

    let url = sourceName;

    if (sourceType) {
      url += `/${sourceType}`;
    }
    if (urlParams.toString().length > 0) {
      url += `?${urlParams}`;
    }

    return url;
  }

  loadNextPage() {
    const {
      hasNextPage,
      settings: { apiUrl }
    } = this.state;
    const { userId, auth } = this.context;

    const { sourceName } = this.props;

    const { setCache } = this.props.cache;

    if (!hasNextPage) {
      return false;
    }

    const apiParams = {
      user_id: auth?.identity || userId
    };

    return new Promise((resolve, reject) => {
      if (typeof sourceName === 'string') {
        const url = this.createURL();

        this.checkCache(url).then(async (cacheData) => {
          let response = cacheData;

          if (!response) {
            response = await request({
              apiUrl,
              params: apiParams,
              endpoint: url
            });
          }

          const {
            error,
            data = response,
            paging: { next: link } = {}
          } = response;

          if (error) {
            reject(error);
            return;
          }

          setCache(url, response);

          this.processData({
            data,
            link,
            resolve
          });
        });
      } else {
        const result = sourceName.map(() => null);

        sourceName.forEach((item, id) => {
          const url = `${item}`;

          this.checkCache(url).then(async (cacheData) => {
            let response = cacheData;

            if (!response) {
              response = await request({
                apiUrl,
                params: apiParams,
                endpoint: url
              });
            }

            const { error, data = response } = response;

            if (error) {
              reject(error);
              return;
            }

            setCache(url, response);

            if (data) {
              result[id] = data;
            }

            if (result.length === sourceName.length && !result.includes(null)) {
              this.setState(
                () => ({
                  hasNextPage: false,
                  nextPageLink: null,
                  stack: result,
                  cursor: data.length
                }),
                () => resolve(true)
              );
            }
          });
        });
      }
    });
  }

  processData({ data, link, resolve }) {
    const { limit, dataType } = this.props;

    this.setState(
      ({ stack: prevStack, cursor: prevCursor }) => {
        const nextCursor = prevCursor + (data ? data.length : 0);
        let nextStack;

        if (dataType === 'array') {
          nextStack = prevStack.concat(data);

          if (limit > 0 && nextStack.length > limit) {
            nextStack = nextStack.slice(0, limit);
          }
        } else {
          nextStack = data;
        }

        return {
          hasNextPage: !!link,
          nextPageLink: link,
          stack: nextStack,
          cursor: nextCursor
        };
      },
      () => resolve(true)
    );
  }

  render() {
    const { children: renderData } = this.props;

    const { data, hasNextItems, loading, error } = this.state;

    return renderData({
      data,
      error,
      loading,
      hasNext: hasNextItems,
      loadNext: this.next
    });
  }
}
